export const CART_STORE_KEY = window?.wc?.wcBlocksData?.CART_STORE_KEY || "wc/store/cart";
export const FULFILLMENT_STORE_KEY = 'epi/fulfillment-sku';
export const CATALOG_STORE_KEY = 'epi/catalog';
export const PRODUCT_DETAILS_STORE_KEY = 'epi/product-details';
